import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getDownloadURL, uploadBytes } from "firebase/storage";
import { collection, deleteDoc, doc, getDoc, getDocs, setDoc, updateDoc, query, where, writeBatch } from "firebase/firestore";
import { database, following, followers, fieldDelete, getFirebaseTimestamp, projects, profiles, profileStars, usernames, stars, tags, targets, storageReference } from "@config/firestore";
import { ADD_USER_PROJECT, DELETE_USER_PROJECT, STORE_USER_PROFILE, STORE_PROFILE_PROJECTS_COUNT, STORE_PROFILE_STARS, SET_CURRENT_TAG_TEXT, SET_TAGS_INPUT, GET_ALL_TAGS, SET_CURRENTLY_PLAYING_PROJECT, REFRESH_USER_PROFILE, SET_FOLLOWING_FILTER_STRING, SET_PROJECT_FILTER_STRING } from "./types";
import { defaultCsd, defaultOrc, defaultSco } from "@root/templates";
import { openSnackbar } from "@comp/snackbar/actions";
import { SnackbarType } from "@comp/snackbar/types";
import { openSimpleModal } from "@comp/modal/actions";
import { selectLoggedInUid } from "@comp/login/selectors";
import { selectCurrentlyPlayingProject } from "./selectors";
import { downloadAllProjectDocumentsOnce, downloadProjectOnce } from "@comp/projects/actions";
import { getProjectLastModifiedOnce } from "@comp/project-last-modified/actions";
import { getPlayActionFromProject, getPlayActionFromTarget } from "@comp/target-controls/utils";
import { downloadTargetsOnce } from "@comp/target-controls/actions";
import { assoc, concat, difference, equals, keys, reject, path, pathOr, hasPath, reduce } from "ramda";
var addUserProjectAction = function addUserProjectAction() {
    return {
        type: ADD_USER_PROJECT
    };
};
var handleProjectTags = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(projectUid, loggedInUserUid, currentTags) {
        var currentProjTagsReference, currentProjTags, newTags, deletedTags, batch;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1)
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return getDocs(query(tags, where(projectUid, "==", loggedInUserUid)));
                    case 2:
                        currentProjTagsReference = _context3.sent;
                        /* eslint-disable-next-line unicorn/prefer-object-from-entries */
                        currentProjTags = currentProjTagsReference.docs.reduce(function (accumulator, document_) {
                            return assoc(document_.id, document_.data(), accumulator);
                        }, {});
                        newTags = reject(function (t) {
                            return keys(currentProjTags).includes(t);
                        }, currentTags);
                        deletedTags = difference(keys(currentProjTags).sort(), currentTags.sort());
                        batch = writeBatch(database);
                        _context3.next = 9;
                        return Promise.all(newTags.map(/*#__PURE__*/ function () {
                            var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(newTag) {
                                return _regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1)
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                batch.set(doc(tags, newTag), _defineProperty({}, projectUid, loggedInUserUid), {
                                                    merge: true
                                                });
                                            case 1:
                                            case "end":
                                                return _context.stop();
                                        }
                                }, _callee);
                            }));
                            return function (_x4) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));
                    case 9:
                        _context3.next = 11;
                        return Promise.all(deletedTags.map(/*#__PURE__*/ function () {
                            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(delTag) {
                                var tagDoc, tagData;
                                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                    while (1)
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _context2.next = 2;
                                                return getDoc(doc(tags, delTag));
                                            case 2:
                                                tagDoc = _context2.sent;
                                                tagData = tagDoc.data();
                                                if (tagData && keys(tagData).length === 1 && keys(tagData)[0] === projectUid) {
                                                    batch.delete(doc(tags, delTag));
                                                }
                                                else if (tagData && keys(tagData).length > 0) {
                                                    batch.update(doc(tags, delTag), _defineProperty({}, projectUid, fieldDelete()));
                                                }
                                            case 5:
                                            case "end":
                                                return _context2.stop();
                                        }
                                }, _callee2);
                            }));
                            return function (_x5) {
                                return _ref3.apply(this, arguments);
                            };
                        }()));
                    case 11:
                        _context3.next = 13;
                        return batch.commit();
                    case 13:
                    case "end":
                        return _context3.stop();
                }
        }, _callee3);
    }));
    return function handleProjectTags(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
export var addUserProject = function addUserProject(name, description, currentTags, projectUid, iconName, iconForegroundColor, iconBackgroundColor) {
    return /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var currentState, loggedInUserUid, newProject, batch, newProjectReference, filesReference, csdFileReference;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            currentState = getState();
                            loggedInUserUid = selectLoggedInUid(currentState);
                            if (!loggedInUserUid) {
                                _context4.next = 26;
                                break;
                            }
                            newProject = {
                                userUid: loggedInUserUid,
                                name: name,
                                created: getFirebaseTimestamp(),
                                description: description,
                                public: true,
                                iconName: iconName,
                                iconForegroundColor: iconForegroundColor,
                                iconBackgroundColor: iconBackgroundColor
                            };
                            _context4.prev = 4;
                            batch = writeBatch(database);
                            newProjectReference = doc(projects);
                            batch.set(newProjectReference, newProject);
                            filesReference = collection(newProjectReference, "files");
                            csdFileReference = doc(filesReference);
                            batch.set(csdFileReference, _objectSpread(_objectSpread({}, defaultCsd), {}, {
                                userUid: loggedInUserUid
                            }));
                            batch.set(doc(filesReference), _objectSpread(_objectSpread({}, defaultOrc), {}, {
                                userUid: loggedInUserUid
                            }));
                            batch.set(doc(filesReference), _objectSpread(_objectSpread({}, defaultSco), {}, {
                                userUid: loggedInUserUid
                            }));
                            batch.set(doc(targets, newProjectReference.id), {
                                targets: {
                                    "project.csd": {
                                        csoundOptions: {},
                                        targetName: "project.csd",
                                        targetType: "main",
                                        targetDocumentUid: csdFileReference.id
                                    }
                                },
                                defaultTarget: "project.csd"
                            }, {
                                merge: true
                            });
                            _context4.next = 16;
                            return batch.commit();
                        case 16:
                            _context4.next = 18;
                            return handleProjectTags(newProjectReference.id, loggedInUserUid, currentTags);
                        case 18:
                            dispatch(addUserProjectAction());
                            dispatch(openSnackbar("Project Added", SnackbarType.Success));
                            _context4.next = 26;
                            break;
                        case 22:
                            _context4.prev = 22;
                            _context4.t0 = _context4["catch"](4);
                            console.log(_context4.t0);
                            dispatch(openSnackbar("Could not add Project", SnackbarType.Error));
                        case 26:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4, null, [[4, 22]]);
        }));
        return function (_x6, _x7) {
            return _ref4.apply(this, arguments);
        };
    }();
};
export var editUserProject = function editUserProject(name, description, currentTags, projectUid, iconName, iconForegroundColor, iconBackgroundColor) {
    return /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var currentState, loggedInUserUid, newProject, newProjectReference;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1)
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            currentState = getState();
                            loggedInUserUid = selectLoggedInUid(currentState);
                            if (!loggedInUserUid) {
                                _context5.next = 20;
                                break;
                            }
                            newProject = {
                                userUid: loggedInUserUid,
                                name: name || "",
                                description: description || "",
                                public: false,
                                iconName: iconName || "",
                                iconForegroundColor: iconForegroundColor || "",
                                iconBackgroundColor: iconBackgroundColor || ""
                            };
                            _context5.prev = 4;
                            _context5.next = 7;
                            return doc(projects, projectUid);
                        case 7:
                            newProjectReference = _context5.sent;
                            _context5.next = 10;
                            return updateDoc(newProjectReference, newProject);
                        case 10:
                            _context5.next = 12;
                            return handleProjectTags(projectUid, loggedInUserUid, currentTags);
                        case 12:
                            dispatch(addUserProjectAction());
                            dispatch(openSnackbar("Project modified", SnackbarType.Success));
                            _context5.next = 20;
                            break;
                        case 16:
                            _context5.prev = 16;
                            _context5.t0 = _context5["catch"](4);
                            console.log(_context5.t0);
                            dispatch(openSnackbar("Could not edit Project", SnackbarType.Error));
                        case 20:
                        case "end":
                            return _context5.stop();
                    }
            }, _callee5, null, [[4, 16]]);
        }));
        return function (_x8, _x9) {
            return _ref5.apply(this, arguments);
        };
    }();
};
var deleteUserProjectAction = function deleteUserProjectAction() {
    return {
        type: DELETE_USER_PROJECT
    };
};
export var deleteUserProject = function deleteUserProject(projectUid) {
    return /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var currentState, loggedInUserUid, files, batch, documentReference;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1)
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            currentState = getState();
                            loggedInUserUid = selectLoggedInUid(currentState);
                            if (!loggedInUserUid) {
                                _context6.next = 20;
                                break;
                            }
                            _context6.next = 5;
                            return getDocs(collection(doc(projects, projectUid), "files"));
                        case 5:
                            files = _context6.sent;
                            batch = writeBatch(database);
                            documentReference = doc(projects, projectUid);
                            batch.delete(documentReference);
                            files.forEach(function (d) {
                                return batch.delete(d.ref);
                            });
                            _context6.prev = 10;
                            _context6.next = 13;
                            return batch.commit();
                        case 13:
                            setTimeout(function () {
                                return dispatch(deleteUserProjectAction());
                            }, 1);
                            dispatch(openSnackbar("Project Deleted", SnackbarType.Success));
                            _context6.next = 20;
                            break;
                        case 17:
                            _context6.prev = 17;
                            _context6.t0 = _context6["catch"](10);
                            dispatch(openSnackbar("Could Not Delete Project", SnackbarType.Error));
                        case 20:
                        case "end":
                            return _context6.stop();
                    }
            }, _callee6, null, [[10, 17]]);
        }));
        return function (_x10, _x11) {
            return _ref6.apply(this, arguments);
        };
    }();
};
export var setCurrentTagText = function setCurrentTagText(text) {
    return {
        type: SET_CURRENT_TAG_TEXT,
        payload: text
    };
};
export var setTagsInput = function setTagsInput(tags) {
    return {
        type: SET_TAGS_INPUT,
        payload: tags
    };
};
export var getAllTagsFromUser = function getAllTagsFromUser(loggedInUserUid, allUserProjectsUids) {
    return /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(dispatch, getStore) {
            var store, currentAllTags, allTags;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1)
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            store = getStore();
                            currentAllTags = pathOr({}, ["ProfiledReducer", "profiles", loggedInUserUid, "allTags"], store);
                            if (allUserProjectsUids) {
                                allTags = reduce(function (accumulator, item) {
                                    return concat(item.tags || [], accumulator);
                                }, [], allUserProjectsUids);
                                if (!equals(currentAllTags, allTags)) {
                                    dispatch({
                                        type: GET_ALL_TAGS,
                                        allTags: allTags,
                                        loggedInUserUid: loggedInUserUid
                                    });
                                }
                            }
                        case 3:
                        case "end":
                            return _context7.stop();
                    }
            }, _callee7);
        }));
        return function (_x12, _x13) {
            return _ref7.apply(this, arguments);
        };
    }();
};
export var addProject = function addProject() {
    return openSimpleModal("new-project-prompt", {
        name: "New Project",
        description: "",
        label: "Create Project",
        newProject: true,
        projectID: "",
        iconName: undefined,
        iconForegroundColor: undefined,
        iconBackgroundColor: undefined
    });
};
export var followUser = function followUser(loggedInUserUid, profileUid) {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8() {
        var batch, followersReference, followersData, followingReference, followingData;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1)
                switch (_context8.prev = _context8.next) {
                    case 0:
                        batch = writeBatch(database);
                        followersReference = doc(followers, profileUid);
                        _context8.next = 4;
                        return getDoc(followersReference);
                    case 4:
                        followersData = _context8.sent;
                        if (followersData.exists()) {
                            batch.update(followersReference, _defineProperty({}, loggedInUserUid, getFirebaseTimestamp()));
                        }
                        else {
                            batch.set(followersReference, _defineProperty({}, loggedInUserUid, getFirebaseTimestamp()));
                        }
                        followingReference = doc(following, loggedInUserUid);
                        _context8.next = 9;
                        return getDoc(followingReference);
                    case 9:
                        followingData = _context8.sent;
                        if (followingData.exists()) {
                            batch.update(followingReference, _defineProperty({}, profileUid, getFirebaseTimestamp()));
                        }
                        else {
                            batch.set(followingReference, _defineProperty({}, profileUid, getFirebaseTimestamp()));
                        }
                        _context8.next = 13;
                        return batch.commit();
                    case 13:
                    case "end":
                        return _context8.stop();
                }
        }, _callee8);
    }));
};
export var unfollowUser = function unfollowUser(loggedInUserUid, profileUid) {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9() {
        var batch;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1)
                switch (_context9.prev = _context9.next) {
                    case 0:
                        batch = writeBatch(database);
                        batch.update(doc(followers, profileUid), _defineProperty({}, loggedInUserUid, fieldDelete()));
                        batch.update(doc(following, loggedInUserUid), _defineProperty({}, profileUid, fieldDelete()));
                        _context9.next = 5;
                        return batch.commit();
                    case 5:
                    case "end":
                        return _context9.stop();
                }
        }, _callee9);
    }));
};
export var updateUserProfile = function updateUserProfile(originalUsername, username, displayName, bio, link1, link2, link3, backgroundIndex) {
    return /*#__PURE__*/ function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var currentState, loggedInUserUid;
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1)
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            currentState = getState();
                            loggedInUserUid = selectLoggedInUid(currentState);
                            if (!loggedInUserUid) {
                                _context10.next = 10;
                                break;
                            }
                            _context10.next = 5;
                            return updateDoc(doc(profiles, loggedInUserUid), {
                                username: username,
                                displayName: displayName,
                                bio: bio,
                                link1: link1,
                                link2: link2,
                                link3: link3,
                                backgroundIndex: backgroundIndex
                            });
                        case 5:
                            _context10.next = 7;
                            return deleteDoc(doc(usernames, originalUsername));
                        case 7:
                            _context10.next = 9;
                            return setDoc(doc(usernames, username), {
                                userUid: loggedInUserUid
                            });
                        case 9:
                            dispatch({
                                type: REFRESH_USER_PROFILE,
                                payload: {
                                    username: username,
                                    displayName: displayName,
                                    bio: bio,
                                    link1: link1,
                                    link2: link2,
                                    link3: link3
                                }
                            });
                        case 10:
                        case "end":
                            return _context10.stop();
                    }
            }, _callee10);
        }));
        return function (_x14, _x15) {
            return _ref10.apply(this, arguments);
        };
    }();
};
export var editProfile = function editProfile(username, displayName, bio, link1, link2, link3, backgroundIndex) {
    return /*#__PURE__*/ function () {
        var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            var currentState, loggedInUserUid, names, existingNames;
            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1)
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            currentState = getState();
                            loggedInUserUid = selectLoggedInUid(currentState);
                            if (!loggedInUserUid) {
                                _context11.next = 9;
                                break;
                            }
                            _context11.next = 5;
                            return getDocs(usernames);
                        case 5:
                            names = _context11.sent;
                            existingNames = [];
                            names.forEach(function (name) {
                                if (name.id !== username) {
                                    existingNames.push(name.id);
                                }
                            });
                            dispatch(openSimpleModal("profile-edit-dialog", {
                                existingNames: existingNames,
                                username: username,
                                displayName: displayName,
                                bio: bio,
                                link1: link1,
                                link2: link2,
                                link3: link3,
                                backgroundIndex: backgroundIndex
                            }));
                        case 9:
                        case "end":
                            return _context11.stop();
                    }
            }, _callee11);
        }));
        return function (_x16, _x17) {
            return _ref11.apply(this, arguments);
        };
    }();
};
export var editProject = function editProject(project) {
    return openSimpleModal("new-project-prompt", {
        name: project.name,
        description: project.description,
        label: "Apply changes",
        projectID: project.projectUid,
        iconName: project.iconName,
        iconForegroundColor: project.iconForegroundColor,
        iconBackgroundColor: project.iconBackgroundColor,
        newProject: false
    });
};
export var deleteProject = function deleteProject(project) {
    return openSimpleModal("delete-project-prompt", {
        projectUid: project.projectUid,
        projectName: project.name
    });
};
export var uploadProfileImage = function uploadProfileImage(loggedInUserUid, file) {
    return /*#__PURE__*/ function () {
        var _ref12 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee12(dispatch) {
            var uploadStorage, imageUrl;
            return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1)
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.prev = 0;
                            _context12.next = 3;
                            return storageReference("images/".concat(loggedInUserUid, "/profile.jpeg"));
                        case 3:
                            uploadStorage = _context12.sent;
                            _context12.next = 6;
                            return uploadBytes(uploadStorage, file);
                        case 6:
                            _context12.next = 8;
                            return getDownloadURL(uploadStorage);
                        case 8:
                            imageUrl = _context12.sent;
                            _context12.next = 11;
                            return updateDoc(doc(profiles, loggedInUserUid), {
                                photoUrl: imageUrl
                            });
                        case 11:
                            dispatch(openSnackbar("Profile Picture Uploaded", SnackbarType.Success));
                            _context12.next = 17;
                            break;
                        case 14:
                            _context12.prev = 14;
                            _context12.t0 = _context12["catch"](0);
                            dispatch(openSnackbar("Profile Picture Upload Failed", SnackbarType.Error));
                        case 17:
                        case "end":
                            return _context12.stop();
                    }
            }, _callee12, null, [[0, 14]]);
        }));
        return function (_x18) {
            return _ref12.apply(this, arguments);
        };
    }();
};
export var playListItem = function playListItem(_ref13) {
    var projectUid = _ref13.projectUid;
    return /*#__PURE__*/ function () {
        var _ref14 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee13(dispatch, getState) {
            var state, currentlyPlayingProject, projectIsCached, projectHasLastModule, timestampMismatch, cachedTimestamp, currentTimestamp, playAction;
            return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1)
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            state = getState();
                            currentlyPlayingProject = selectCurrentlyPlayingProject(state);
                            if (!(projectUid === false)) {
                                _context13.next = 5;
                                break;
                            }
                            console.log("playListItem: projectUid is false");
                            return _context13.abrupt("return");
                        case 5:
                            if (!(projectUid !== currentlyPlayingProject)) {
                                _context13.next = 8;
                                break;
                            }
                            _context13.next = 8;
                            return dispatch({
                                type: SET_CURRENTLY_PLAYING_PROJECT,
                                projectUid: undefined
                            });
                        case 8:
                            projectIsCached = hasPath(["ProjectsReducer", "projects", projectUid], state);
                            projectHasLastModule = hasPath(["ProjectLastModifiedReducer", projectUid, "timestamp"], state);
                            timestampMismatch = false;
                            if (projectIsCached && projectHasLastModule) {
                                cachedTimestamp = path(["ProjectsReducer", "projects", projectUid, "cachedProjectLastModified"], state);
                                currentTimestamp = path(["ProjectLastModifiedReducer", projectUid, "timestamp"], state);
                                if (cachedTimestamp && currentTimestamp) {
                                    timestampMismatch = cachedTimestamp.toMillis() !== currentTimestamp.toMillis();
                                }
                            }
                            if (!(!projectIsCached || timestampMismatch || !projectHasLastModule)) {
                                _context13.next = 24;
                                break;
                            }
                            _context13.next = 15;
                            return downloadProjectOnce(projectUid)(dispatch);
                        case 15:
                            _context13.next = 17;
                            return downloadAllProjectDocumentsOnce(projectUid)(dispatch);
                        case 17:
                            _context13.next = 19;
                            return downloadTargetsOnce(projectUid)(dispatch);
                        case 19:
                            _context13.next = 21;
                            return getProjectLastModifiedOnce(projectUid)(dispatch);
                        case 21:
                            _context13.next = 23;
                            return playListItem({
                                projectUid: projectUid
                            })(dispatch, getState);
                        case 23:
                            return _context13.abrupt("return", _context13.sent);
                        case 24:
                            playAction = getPlayActionFromTarget(projectUid)(state) || getPlayActionFromProject(projectUid, state);
                            if (!playAction) {
                                _context13.next = 31;
                                break;
                            }
                            playAction(dispatch);
                            _context13.next = 29;
                            return dispatch({
                                type: SET_CURRENTLY_PLAYING_PROJECT,
                                projectUid: projectUid
                            });
                        case 29:
                            _context13.next = 31;
                            break;
                        case 31:
                        case "end":
                            return _context13.stop();
                    }
            }, _callee13);
        }));
        return function (_x19, _x20) {
            return _ref14.apply(this, arguments);
        };
    }();
};
export var storeProfileProjectsCount = function storeProfileProjectsCount(projectsCount, profileUid) {
    return {
        type: STORE_PROFILE_PROJECTS_COUNT,
        projectsCount: projectsCount,
        profileUid: profileUid
    };
};
export var storeUserProfile = function storeUserProfile(profile, profileUid) {
    return {
        type: STORE_USER_PROFILE,
        profile: profile,
        profileUid: profileUid
    };
};
export var storeProfileStars = function storeProfileStars(stars, profileUid) {
    return {
        type: STORE_PROFILE_STARS,
        profileUid: profileUid,
        stars: stars
    };
};
export var setProjectFilterString = function setProjectFilterString(payload) {
    return {
        type: SET_PROJECT_FILTER_STRING,
        payload: payload
    };
};
export var setFollowingFilterString = function setFollowingFilterString(payload) {
    return {
        type: SET_FOLLOWING_FILTER_STRING,
        payload: payload
    };
};
export var starOrUnstarProject = function starOrUnstarProject(projectUid, loggedInUserUid) {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee14() {
        var batch, currentProjectStarsReference, currentProjectStars, currentlyStarred;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1)
                switch (_context14.prev = _context14.next) {
                    case 0:
                        if (!(!projectUid || !loggedInUserUid)) {
                            _context14.next = 2;
                            break;
                        }
                        return _context14.abrupt("return");
                    case 2:
                        batch = writeBatch(database);
                        _context14.next = 5;
                        return getDoc(doc(stars, projectUid));
                    case 5:
                        currentProjectStarsReference = _context14.sent;
                        currentProjectStars = currentProjectStarsReference.exists() ? currentProjectStarsReference.data() : {};
                        currentlyStarred = keys(currentProjectStars || []).includes(loggedInUserUid);
                        if (currentlyStarred) {
                            batch.update(doc(stars, projectUid), _defineProperty({}, loggedInUserUid, fieldDelete()));
                            batch.update(doc(profileStars, loggedInUserUid), _defineProperty({}, projectUid, fieldDelete()));
                        }
                        else {
                            batch.set(doc(stars, projectUid), _defineProperty({}, loggedInUserUid, getFirebaseTimestamp()), {
                                merge: true
                            });
                            batch.set(doc(profileStars, loggedInUserUid), _defineProperty({}, projectUid, getFirebaseTimestamp()), {
                                merge: true
                            });
                        }
                        _context14.next = 11;
                        return batch.commit();
                    case 11:
                    case "end":
                        return _context14.stop();
                }
        }, _callee14);
    }));
};
